import {Injectable} from '@angular/core'
import {environment} from 'environments/environment'

@Injectable()
export class LoggerService {
  constructor() {}

  public log(message?: any, ...optionalParams: any[]) {
    if (!environment.production) {
    }
  }

  public error(message?: any, ...optionalParams: any[]) {
    if (!environment.production) {
      console.error(message, optionalParams)
    }
  }
}
